<div class="blog-slider5">
  <div class="container">
    <div class="main-card" >
      <div class="cards"  >
        <div class="card">
          <div class="regle">
            <img style="border: solid 2px; border-radius: 50px; border-color: aqua;" src="https://www.ionos.fr/digitalguide/fileadmin/DigitalGuide/Teaser/data-security-t.jpg"/>
            <br><br><br><br>
            <h1 class="regle">Politique de confidentialité</h1>
            <small class="regle">Date d’entrée en vigueur le 07 Fév mai 2022</small>
            <p class="regle">
              La protection des données est particulièrement prioritaire pour la gestion
              du TemplateMonster.com. Lorsque le traitement de vos données personnelles
              est nécessaire et s’il n’y a pas de base pour un tel traitement, nous
              obtiendrons votre consentement.
            </p>
            <p>
              Le traitement des données personnelles, y compris votre nom, adresse,
              adresse électronique ou numéro de téléphone, sera toujours conforme au
              Règlement Général sur la Protection des Données (GDPR) et aux
              Réglementations de protection des données (spécifiques au pays) applicables
              à TemplateMonster.com.
            </p>
            <p>
              Via cette déclaration de protection des données, nous informons le grand
              public de la nature, de la portée et du but des données personnelles que
              nous collectons, utilisons et traitons. De plus, vous êtes informé, par
              cette déclaration de protection des données, des droits auxquels vous avez
              droit.
            </p>
            <p>
              En tant que contrôleur de données et processeur de données,
              TemplateMonster.com a mis en place de nombreuses mesures techniques et
              organisationnelles pour assurer une protection complète de vos données
              personnelles via le site Web. Étant donné que les transmissions de données
              sur Internet peuvent présenter des failles de sécurité, la protection
              absolue n’est pas garantie. C’est pourquoi, chaque personne concernée est
              libre de nous transférer des données personnelles par tous les moyens
              disponibles, par ex. par email ou par téléphone.
            </p>
            <p>
              <b>Dans cette Politique, nous allons expliquer:</b>
            </p>

            <ul>
              <li>
                <b>Quels types d’informations sont collectés par TemplateMonster ?</b>
              </li>
              <li><b>Comment collectons-nous des informations personnelles ?</b></li>
              <li>
                <b
                  >Quelles informations personnelles recueillons-nous à votre sujet auprès
                  des autres ?</b
                >
              </li>
              <li>
                <b
                  >Comment TemplateMonster utilise-t-il les informations personnelles ?</b
                >
              </li>
              <li><b>Quand divulguons-nous vos informations personnelles ?</b></li>
              <li>
                <b
                  >Où transférons-nous et / où stockons-nous vos informations personnelles
                  ?</b
                >
              </li>
              <li>
                <b>Combien de temps gardons-nous vos informations personnelles ?</b>
              </li>
              <li>
                <b>Comment vos informations personnelles sont-elles conservées ?</b>
              </li>
              <li>
                <b
                  >Comment pouvez-vous accéder et gérer vos informations personnelles ?</b
                >
              </li>
              <li><b>Choix de marketing concernant vos informations personnelles.</b></li>
              <li><b>Effacement systématique et blocage des données personnelles.</b></li>
              <li><b>Confidentialité des enfants.</b></li>
              <li><b>Changements dans notre Politique de confidentialité.</b></li>
              <li><b>Informations de contact.</b></li>
            </ul>

            <p><b>Quels types d’informations sont collectés par TemplateMonster ?</b></p>
            <p>
              Nous recueillons certaines informations sur les visiteurs et les
              utilisateurs de nos sites Web.
            </p>

            <li style="color: black">
              <b>Informations que nous obtenons des fournisseurs</b>
            </li>
            <p>
              Nom, nom de la société, adresse, adresse e-mail, numéro (s) de téléphone,
              détails de paiement (comme les informations de votre carte de crédit),
              réponses aux enquêtes lancées à des fins de recherche et demandes de
              support.
            </p>
            <p>
              Cette information est utilisée pour vous fournir et / ou améliorer nos
              services ; par exemple, payer des commissions, vérifier votre identité, vous
              contacter, vous fournir de la publicité et du marketing, et vous facturer.
              Nous utilisons cette information pour nous assurer que nous respectons les
              exigences légales.
            </p>

            <li style="color: black">
              <b>Informations que nous obtenons des acheteurs</b>
            </li>
            <p>
              Names, member names, email address, phone number, other contact details,
              information about your computer and about your visits to and use of this
              website (including information about your browser, IP address, general
              location by your browser), responses to the surveys initiated for research
              purposes, payment details (like your credit card information ), transaction
              details, support queries, web analytics data and information that you
              provide when you fill in forms on our websites.
            </p>
            <p>
              Nous pouvons utiliser ces informations pour répondre à vos demandes ou
              correspondance, pour fournir le service client (ou à des fins statistiques),
              faire l’analyse à des fins de gestion afin d’administrer le site, améliorer
              les produits / services, envoyer des avis techniques / mises à jour, alertes
              de sécurité, modifications dans les notifications de politiques, les
              messages administratifs, de sorte que nous pourrions prévenir la fraude, la
              violation des politiques / termes, et des menaces ou des dommages.
            </p>

            <li style="color: black">
              <b>Informations que nous obtenons de nos partenaires</b>
            </li>
            <p>
              Nom, nom de la société, URL du site, numéro de téléphone, adresse, type
              d’entreprise, adresse e-mail et informations provenant des processeurs
              marchands tels que l’adresse e-mail ou ID PayPal. Nous utilisons ces
              informations pour vous contacter, vous payer et filtrer les risques, les
              fraudes ou d’autres types de problèmes similaires, vous envoyer des avis
              techniques, des mises à jour, des alertes de sécurité, des informations sur
              les modifications apportées à nos règles et des messages d’assistance et
              d’administration.
            </p>

            <li style="color: black">
              <b>Informations que nous obtenons des visiteurs du site</b>
            </li>
            <p>
              Le type d’appareil et le navigateur que vous utilisez, la connexion réseau,
              l’adresse IP, les informations sur les cookies installés sur votre appareil,
              les requêtes d’assistance et les données d’analyse Web. En outre, nous
              pouvons collecter des informations personnelles que vous nous soumettez via
              n’importe quelle fonctionnalité disponible sur l’un de nos sites Web.
            </p>

            <li style="color: black">
              <b
                >Informations que nous obtenons des utilisateurs qui ont fait référence au
                support par chat</b
              >
            </li>
            <p>
              Nom, adresse e-mail, informations sur l’appareil et le navigateur que vous
              utilisez, la transcription du chat et d’autres informations personnelles que
              vous nous fournissez pendant notre discussion. Conformément à nos Conditions
              d’utilisation, nous pouvons vous demander des documents supplémentaires
              pendant notre conversation pour vérifier votre identité.
            </p>

            <li style="color: black">
              <b>Comment collectons-nous les informations personnelles ?</b>
            </li>
            <p>
              <li
                style="
                  color: black;
                  margin-left: 50px;
                  margin-right: 50px;
                  margin-top: 20px;
                "
              >
                Lorsque vous effectuez certaines actions comme inscription sur nos sites
                Web, achat / commande des articles ou des services sur nos sites,
                abonnement à notre newsletter, soumission des commentaires, participation
                aux concours, remplissage du sondage ou envoie d’une communication via
                n’importe quelle option disponible.
              </li>
              <li
                style="
                  color: black;
                  margin-left: 50px;
                  margin-right: 50px;
                  margin-top: 20px;
                "
              >
                Nous collectons automatiquement des informations personnelles lorsque vous
                naviguez sur les sites ou via la partie tierce lorsque vous utilisez les
                services associés à nos sites.
              </li>
              <li
                style="
                  color: black;
                  margin-left: 50px;
                  margin-right: 50px;
                  margin-top: 20px;
                "
              >
                Vous pouvez être invité à fournir des informations de connexion à votre
                site Web ou votre compte d’hébergement (serveur) dans le cas où vous avez
                commandé des services supplémentaires de nos partenaires comme
                l’installation de modèles, l’implémentation de logos, l’installation de
                plugins WordPress, etc. Dans ce cas, vous pouvez ou non fournir des
                informations de connexion à votre site Web ou votre compte d’hébergement,
                sachez que si vous refusez de fournir des informations de connexion à nos
                partenaires, ils ne pourront pas effectuer le service que vous avez
                commandé.
              </li>
            </p>

            <li style="color: black">
              <b
                >Quelles informations personnelles recueillons-nous à votre sujet auprès
                des autres ?</b
              >
            </li>
            <p>
              Même si nous collectons des informations personnelles directement auprès de
              vous, nous pouvons parfois recueillir certaines informations vous concernant
              auprès d’autres sources.
            </p>

            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Détails financiers et / ou de transaction des fournisseurs de paiement (afin
              de traiter la transaction).
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Des services tiers tels que Google, Facebook, Twitter peuvent nous fournir
              certaines informations vous concernant lorsque vous vous liez / connectez /
              inscrivez à un fournisseur tiers. La quantité d’informations peut varier et
              peut être / est contrôlée par ce fournisseur de services ou par vous via les
              contrôles de paramètres de confidentialité disponibles dans les paramètres
              de compte de ce fournisseur de services.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Des parties tierces, nous pouvons obtenir des données démographiques, des
              informations de détection de fraude, combiner avec les informations que nous
              avons sur vous, pour confirmer votre identité, ceux-ci peuvent être des
              services de vérification d’identité utilisés pour prévenir les fraudes.
            </li>

            <li style="color: black">
              <b>Comment TemplateMonster utilise-t-il les informations personnelles ?</b>
            </li>

            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Vos informations sont utilisées lorsque nous avons besoin de définir votre
              identité pour faciliter le traitement des transactions effectuées sur l’un
              de nos sites Web, par exemple lorsque vous achetez des articles sur notre
              place de marché.
            </li>

            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              D’autres intérêts légitimes peuvent inclure : fourniture des services
              décrits sur l’un de nos sites Web ;
            </li>

            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              vérifiсation de votre identité lorsque vous vous connectez à l’un de nos
              sites Web ;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              fourniture des services de soutien;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              partage avec vous les nouvelles de l’entreprise et les mises à jour de sites
              Web / services ;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Vérification de vos actions sur nos sites Web pour identifier les activités
              potentiellement frauduleuses et assurer le respect des conditions
              d’utilisation qui s’appliquent aux sites Web ;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              réponse à vos commentaires ou questions sur nos sites Web, demande de vos
              commentaires ou vos opinions via des sondages ;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              gestion des affaires juridiques et opérationnelles, y compris la gestion des
              risques liés au contenu et à la fraude ;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              amélioration de nos produits et services.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Lorsque vous nous donnez votre consentement : pour vous fournir des
              informations marketing sur les produits et services susceptibles de vous
              intéresser ; pour modifier / personnaliser nos services et sites web, comme
              la publicité qui apparaît sur notre site, cela implique l’utilisation de
              cookies pour offrir une expérience personnalisée.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              À des fins multiples requises par la loi.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Pour l’octroi d’une cour de justice, les autorités d’application de la loi,
              les demandes du gouvernement ou toute autre occasion qui peut se rapporter
              aux enquêtes.
            </li>

            <li style="color: black">
              <b>Quand divulguons-nous vos informations personnelles ? </b>
            </li>
            <p>Vos informations personnelles peuvent être consultées par :</p>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              les personnes qui en ont besoin pour accomplir leurs tâches ;
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              les tiers qui ont un but légitime pour y accéder.
            </li>
            <p>
              Nous pouvons partager vos renseignements personnels avec des tiers dans les
              cas suivants, lorsque :
            </p>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              le client concerné a consenti à la divulgation.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              il est nécessaire à des fins de support et / ou de validation / activation
              de licence.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              les sous-traitants ou les prestataires de services qui nous aident de toutes
              les manières possibles, les sous-traitants et / ou les prestataires de
              services peuvent transférer et accéder à vos informations personnelles
              depuis d’autres pays dans lesquels ils ont des opérations.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              il est requis par la loi soit de protéger nos droits, ou quelqu’un de la
              blessure, et / ou de se conformer à une procédure judiciaire, une ordonnance
              du tribunal, ou un processus juridique servi sur la Société.
            </li>

            <li style="color: black">
              <b
                >Où transférons-nous et / où stockons-nous vos informations personnelles
                ?</b
              >
            </li>

            <p>
              TemplateMonster.com a ses principales installations de fabrication situées
              aux États-Unis, ainsi qu’un certain nombre de filiales de soutien situées en
              Ukraine, en Inde, au Japon
            </p>
            <p>
              Les sociétés de support fournissent uniquement un rôle de support interne à
              et pour le bénéfice de TemplateMonster.com. Ceci est exécuté en fonction de
              votre consentement à cette politique. Pour protéger vos informations, nous
              travaillons avec des sous-traitants qui peuvent maintenir un niveau
              acceptable de conformité à la sécurité des données.
            </p>
            <p>
              En outre, nous pouvons fournir certains détails personnels aux fournisseurs
              du marché TemplateMonster.com afin qu’ils puissent offrir un support produit
              à leurs clients.
            </p>

            <li style="color: black">
              <b>Combien de temps gardons-nous vos informations personnelles ?</b>
            </li>
            <p>
              Vos informations privées sont conservées sur nos serveurs aussi longtemps
              que nécessaire pour vous fournir nos services et pour nous conformer aux
              obligations légales.
            </p>
            <p>
              i vous ne souhaitez pas que nous stockons vos informations personnelles,
              vous avez le droit de les effacer, mais dans ce cas, nous devons fermer
              votre compte TemplateMonster.
            </p>
            <p>
              Toutes les informations sur les comptes supprimés sont conservées sur nos
              serveurs afin que nous puissions les utiliser pour nos intérêts commerciaux
              légitimes : respecter la loi, prévenir la fraude, résoudre les litiges,
              résoudre les problèmes, aider aux enquêtes, appliquer les conditions de
              service et / ou prendre d’autres actions autorisées par la loi. Les
              informations que nous conservons seront traitées conformément à cette
              politique de confidentialité.
            </p>

            <li style="color: black">
              <b>Comment vos informations personnelles sont-elles conservées ?</b>
            </li>
            <p>
              Afin de sécuriser vos informations, nous appliquons certaines mesures
              organisationnelles pour les protéger contre une utilisation non autorisée ou
              illégale et une perte ou destruction accidentelle.
            </p>

            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Nous partageons et fournissons l’accès à vos informations dans la mesure du
              possible, sous réserve de restrictions de confidentialité, le cas échéant,
              et de manière anonyme dans la mesure du possible.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Pour stocker vos informations, nous utilisons des serveurs sécurisés.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Nous vérifions l’identité de tous les individus qui demandent l’accès à des
              informations privées avant de leur accorder l’accès.
            </li>
            <li
              style="
                color: black;
                margin-left: 300px;
                margin-right: 50px;
                margin-top: 20px;
              "
            >
              Nous utilisons le cryptage de certificat SSL pour protéger le transfert de
              données.
            </li>

            <p>
              Assurez-vous que vos informations sont sécurisées. Nous ne sommes pas
              responsables si vous essayez de contourner les paramètres de confidentialité
              sur nos sites Web. Dans le cas où nous vous donnons le mot de passe à
              certaines parties de notre site Web, vous êtes responsable de la sécurité.
              Vous ne devez pas le partager avec des tiers en particulier des
              commentaires, des questions, car ces zones peuvent être consultées par
              n’importe quel utilisateur de nos sites Web.
            </p>

            <p>
              Pour des raisons évidentes, nous ne sommes pas en mesure de contrôler les
              actions des utilisateurs sur nos sites Web. C’est pourquoi vous devez
              partager judicieusement vos informations dans les zones publiques de nos
              sites Web, car nous ne pouvons pas garantir que vos informations ne seront
              pas consultées par des tiers non autorisés.
            </p>

            <p>
              Lorsque vous choisissez de partager vos informations via le site Web tierce,
              vous devez vérifier la politique de confidentialité de ce site pour être au
              courant de leurs pratiques de gestion / protection de l’information.
            </p>

            <li style="color: black">
              <b>Comment pouvez-vous accéder et gérer vos informations personnelles ?</b>
            </li>
            <p>
              outes les informations personnelles que nous collectons à votre sujet sont
              disponibles dans votre compte. Vous avez le droit de faire toutes les
              modifications et corrections nécessaires des erreurs disponibles dans ces
              données.
            </p>
            <p>
              Vous pouvez recevoir vos informations personnelles dans un format structuré
              et lisible par machine, les effacer ou restreindre leur traitement. Vous
              pouvez également vous opposer au traitement de vos données personnelles en
              fonction de vos intérêts légitimes, tels que le profilage pour le marketing
              direct et les cas où nous avons demandé votre consentement pour traiter vos
              données.
            </p>
            <p>
              Dans certaines situations ces droits peuvent être limités, il existe un
              certain nombre de cas quand nous pouvons conserver vos informations après
              avoir retiré votre consentement.
            </p>
            <p>
              Les cas quand nous pouvons exiger que vos informations personnelles soient
              conformes à des obligations légales ou contractuelles. Si vous ne nous
              fournissez pas de telles données, nous ne serons pas en mesure de gérer les
              relations avec vous. Dans tous les autres cas, la fourniture des
              informations demandées peut être facultative.
            </p>
            <p>
              S’il arrive que vous ayez des problèmes non résolus, vous avez droit de vous
              plaindre auprès des autorités de protection des données. Si vous croyez que
              vos droits à la vie privée ont été violés, veuillez nous contacter à
              <a href="#">privacy@templatemonster.com</a>
            </p>

            <li style="color: black">
              <b> Choix de marketing concernant vos informations personnelles</b>
            </li>

            <p>
              Dans le cas où nous aurions votre consentement, nous vous enverrons des
              documents de marketing qui comprendront des informations sur les produits,
              les services, les réductions que nous pensons être intéressantes pour vous.
              Si vous décidez de ne pas recevoir cette notification par e-mail, vous
              pouvez facilement vous désabonner en utilisant l’option de désabonnement ou
              nous contactant via
              <a href="" target="_Blank"> unsubscribe@templatemonster.com</a>
            </p>
            <p><b>Cookies</b></p>
            <p>
              TemplateMonster.com et tous les sites Web et partenaires utilisent des
              cookies pour analyser le comportement des utilisateurs, recueillir des
              informations démographiques sur notre base d’utilisateurs en général. Un
              cookie est un petit fichier placé sur votre appareil lorsque vous visitez un
              site Web.En utilisant les paramètres du navigateur de votre appareil, vous
              pouvez utiliser des cookies, au cas où vous les désactivez vous limiterez
              certaines fonctionnalités sur nos sites Web.
            </p>
            <p>
              Nous utilisons des cookies fonctionnels et analytiques, pour plus
              d’informations sur l’utilisation des cookies, veuillez consulter notre
              <a href="https://www.templatemonster.com/fr/cookie-policy/" target="_Blank">
                cookies policy </a
              >, ou visiter
              <a href="https://www.allaboutcookies.org/"> www.allaboutcookies.org</a>
            </p>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</div>
